import { useState, useEffect } from 'react';
import { getClasses } from '@/actions/data-fetch-classes';
import { ClassesClientWrapper } from './ClassesClientWrapper';
import { Class, ClassPagination } from '@/actions/data-fetch-classes';

export default function ClassesPage() {
  const [initialData, setInitialData] = useState<Class[] | undefined>(undefined);
  const [pagination, setPagination] = useState<ClassPagination | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getClasses({
          page: 1
        });

        if (response.success && response.data) {
          setInitialData(response.data.data);
          setPagination(response.data.pagination);
        }
      } catch (err) {
        console.error('Error fetching classes:', err);
        setError('Failed to load classes');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg">Loading classes...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg text-red-600">{error}</div>
      </div>
    );
  }

  return (
    <div>
      <ClassesClientWrapper
        initialData={initialData || []}
        pagination={pagination || {
          currentPage: 1,
          totalPages: 1,
          totalCount: 0,
          itemsPerPage: 10,
          hasNextPage: false,
          hasPreviousPage: false
        }}
      />
    </div>
  );
}
